import { Permission } from '@insio/shared-types';

/** Whether a person may change the automation settings: whoever may manage the rules. */
export function canChangeAutomationSettings(
  hasPermission: (permission: Permission) => boolean
): boolean {
  return hasPermission(Permission.RULES_MANAGE);
}
